// extracted by mini-css-extract-plugin
export default {"avatar-link":"styles_avatar-link__vonG-","avatarLink":"styles_avatar-link__vonG-"};